<script lang="ts" setup>
const props = defineProps<{
  type?:
    | 'primary'
    | 'dark'
    | 'secondary'
    | 'tertiary'
    | 'light-primary'
    | 'light-secondary'
    | 'light-tertiary'
  bold?: boolean
  block?: boolean
  center?: boolean
  width?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
  ellipsis?: boolean
  rows?: number
  deleted?: boolean
}>()

const textRef = ref<HTMLSpanElement>()
</script>

<template>
  <span
    ref="textRef"
    class="m-text"
    :class="[type, { block, center, bold, deleted, ellipsis }]"
    :style="{
      fontSize: `var(--font-size-${size || 'md'})`,
      width,
      '-webkit-line-clamp': rows || 1
    }"
  >
    <slot />
  </span>
</template>

<style lang="scss" scoped>
.m-text {
  color: var(--text);
  text-wrap: unset;
  word-break: break-word;
  word-wrap: break-word;
  &.primary {
    color: var(--text-primary);
  }
  &.dark {
    color: var(--text-dark);
  }
  &.secondary {
    color: var(--text-secondary);
  }
  &.tertiary {
    color: var(--text-tertiary);
  }
  &.light-primary {
    color: var(--text-light);
  }
  &.light-secondary {
    color: var(--text-light);
  }
  &.block {
    display: block;
  }
  &.center {
    text-align: center;
  }
  &.bold {
    font-weight: bold;
  }
  &.deleted {
    color: var(--text-quaternary);
    text-decoration: line-through;
    font-size: var(--font-size-xs) !important;
  }
  &.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    * {
      display: inline;
    }
  }
}
</style>
